export const ORIGINAL_IMAGE_SOURCE = "origin";

const LEGACY_ORIGINAL_IMAGE_SOURCE = "original";

export const hasExplicitSource = (source) => source != null && source !== "";

const isOriginalSource = (source) =>
  !source ||
  source === ORIGINAL_IMAGE_SOURCE ||
  source === LEGACY_ORIGINAL_IMAGE_SOURCE;

/**
 * Resolves `source` for an image cropped from an existing product image.
 * - Parent source is "origin" (or missing) → parent picture path
 * - Parent source is another picture name → same name
 * @param {{ path?: string, source?: string } | null | undefined} sourceMedia
 * @returns {string}
 */
export const resolveCroppedImageSource = (sourceMedia) => {
  if (!sourceMedia?.path) return ORIGINAL_IMAGE_SOURCE;

  if (isOriginalSource(sourceMedia.source)) {
    return sourceMedia.path;
  }

  return sourceMedia.source;
};

/** Label shown under product image thumbnails. */
export const formatImageSourceDisplay = (img) =>
  isOriginalSource(img?.source) ? ORIGINAL_IMAGE_SOURCE : img.source;
